import Partdetails from './Partdetails'
import ServiceConfigDetails from '$components/ServiceConfigDetails'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

const ExpandedRow = ({ record, isMyServicesPage }) => {
  const { t } = useTranslation()
  return (
    <>
      <Partdetails record={record} />
      <ServiceConfigDetails
        record={record}
        title={t('bookedservices.my_provided_information')}
        style={{ width: '71%', marginLeft: '24px' }}
        isMyServicesPage={isMyServicesPage}
      />
    </>
  )
}

ExpandedRow.propTypes = {
  record: PropTypes.object,
  isMyServicesPage: PropTypes.bool,
}

export default ExpandedRow
